import { defineMessages } from "react-intl";

export const scope = "components.NavBar";

export const messages = defineMessages({
  investmentsLabel: {
    id: `${scope}.investmentsLabel`,
    defaultMessage: "Inversiones",
  },
  localMarketLabel: {
    id: `${scope}.localMarketLabel`,
    defaultMessage: "Mercado Local",
  },
  globalMarketLabel: {
    id: `${scope}.globalMarketLabel`,
    defaultMessage: "Mercado Global",
  },
  withdrawLabel: {
    id: `${scope}.withdrawLabel`,
    defaultMessage: "Enviar",
  },
  operationsLabel: {
    id: `${scope}.operationsLabel`,
    defaultMessage: "Operaciones",
  },
  swapLabel: {
    id: `${scope}.swapLabel`,
    defaultMessage: "Operar",
  },
  cardsLabel: {
    id: `${scope}.cardsLabel`,
    defaultMessage: "Tarjetas",
  },
  depositLabel: {
    id: `${scope}.depositLabel`,
    defaultMessage: "Recibir",
  },
  homeLabel: {
    id: `${scope}.homeLabel`,
    defaultMessage: "Inicio",
  },
  balanceLabel: {
    id: `${scope}.balanceLabel`,
    defaultMessage: "Cuentas",
  },
  multipleLabel: {
    id: `${scope}.multipleLabel`,
    defaultMessage: "Envío múltiple",
  },
  dollarizeLabel: {
    id: `${scope}.dollarizeLabel`,
    defaultMessage: "Dolarizar",
  },
  profileLabel: {
    id: `${scope}.profileLabel`,
    defaultMessage: "Perfil",
  },
  helpCenterLabel: {
    id: `${scope}.helpCenterLabel`,
    defaultMessage: "Centro de ayuda",
  },
  contactLabel: {
    id: `${scope}.contactLabel`,
    defaultMessage: "Atención al cliente",
  },
  logOutLabel: {
    id: `${scope}.logOutLabel`,
    defaultMessage: "Cerrar sesión",
  },
  historyLabel: {
    id: `${scope}.historyLabel`,
    defaultMessage: "Historiales",
  },
  bymaLabel: {
    id: `${scope}.bymaLabel`,
    defaultMessage: "Mercado Local",
  },
});
